"use strict";

exports.__esModule = true;
exports.placements = void 0;
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];
exports.placements = placements;
//# sourceMappingURL=constants.js.map